import { render, staticRenderFns } from "./offDay.vue?vue&type=template&id=63c98482"
import script from "./offDay.vue?vue&type=script&lang=js"
export * from "./offDay.vue?vue&type=script&lang=js"
import style0 from "./offDay.vue?vue&type=style&index=0&id=63c98482&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports